import { LevelAbbreviations } from "../Types";

export const UrbanSettlementTypes: LevelAbbreviations[] = [
    {
        long: "г.п.",
        short: "Городское поселение",
        fiasKey: "1",
    },
    {
        long: "Сельское поселение",
        short: "с.п.",
        fiasKey: "2",
    },
    {
        long: "Межселенная территория в составе муниципального района",
        short: "межсел.тер.",
        fiasKey: "3",
    },
    {
        long: "Внутригородской район городского округа",
        short: "вн.р-н",
        fiasKey: "4",
    },
];
